var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    { attrs: { label: "全部品牌:" } },
    [
      _c(
        "el-select",
        {
          on: {
            change: function ($event) {
              return _vm.$emit("change")
            },
          },
          model: {
            value: _vm.listQuery.search_agent_id,
            callback: function ($$v) {
              _vm.$set(_vm.listQuery, "search_agent_id", $$v)
            },
            expression: "listQuery.search_agent_id",
          },
        },
        [
          _c("el-option", { attrs: { label: "全部", value: "0" } }),
          _vm._v(" "),
          _vm._l(_vm.platList, function (item) {
            return item.mini_name
              ? _c("el-option", {
                  attrs: { label: item.mini_name, value: item.agent_id },
                })
              : _vm._e()
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }